import { SegmentService } from "@main-services/segment.service";
import { New_AccountRemote } from "../../infrastructure/new_account.remote";
import { New_AccountBridgeService } from "./new_account-bridge.service";
import { NewAccountStateService } from "./new_account.state.service";
import { Injectable } from "@angular/core";
import { tap } from "rxjs/operators";
import { Term } from "@models/term";
import { Router } from "@angular/router";
import { NewAccount } from "../entities/new_account.model";
import { Observable } from "rxjs";
import { RudderstackService } from "@main-services/rudderstack.service";

@Injectable({
	providedIn: "root"
})
export class NewAccountFacade {
	constructor(
		private readonly new_AccountStateService: NewAccountStateService,
		private readonly new_AccountBridgeService: New_AccountBridgeService,
		private readonly new_AccountRemote: New_AccountRemote,
		private readonly segmentService: SegmentService,
		private readonly rudderstackService: RudderstackService,
		private readonly router: Router
	) {}

	public getAccount(): Observable<NewAccount> {
		if (!this.new_AccountStateService.isAccountLoaded()) {
			// TODO: GET ACCOUNT FROM WHERE ITS NEEDED (Remote)
			this.new_AccountStateService.updateAccount(this.new_AccountBridgeService.getAccount());
		}

		return this.new_AccountStateService.getAccount$();
	}

	public updateAccount(account: NewAccount): Observable<NewAccount> {
		this.new_AccountBridgeService.updateOldAccount(account);
		return this.new_AccountRemote.getAccount(account).pipe(
			tap((account: NewAccount) => {
				this.preventUpdateWhenNoTermsAccepted(account);
				this.new_AccountStateService.updateAccount(account);
			})
		);
	}

	// TODO_NEW Remove from this service. Should be placed anywhere else
	public fetchMembersData(): void {
		this.new_AccountBridgeService.fetchMembersData();
	}

	public acceptBest2Terms(): void {
		this.new_AccountStateService.acceptBest2Terms();
	}

	private preventUpdateWhenNoTermsAccepted(account: NewAccount): void {
		if (!this.hasTermsAccepted(account.terms)) {
			this.segmentService.reset();
			this.rudderstackService.reset();
			this.router.navigateByUrl("/user/logout");
		}
	}

	private hasTermsAccepted(terms: Term[]): boolean {
		return terms.every((term: Term) => term.hasSigned());
	}
}
